import { CurrentUserSessionHelper } from "../CurrentUserSessionHelper";

/**
 * Whether a sidebar menu item shows for a user with the given cognito groups.
 * Items with a `requiredGroup` need that group; every other item shows for
 * everyone.
 *
 * @param {Object} item - A SliderMenu entry or sub-menu entry.
 * @param {Array} groups - The user's cognito groups.
 * @returns {Boolean}
 */
export const isMenuItemVisible = ({ requiredGroup }, groups) =>
  !requiredGroup || CurrentUserSessionHelper.userCognitoGroupsInclude(groups, requiredGroup);
